<template>
  <div class="home-view">
    <!-- 碰撞反弹图片 -->
    <div class="bouncing-wrapper" ref="bouncingWrapper">
      <img ref="bouncingImg" :src="bouncingImgSrc" class="bouncing-img" :class="{ 'bouncing-img_paused': isPaused }"
        :style="{ left: imgX + 'px', top: imgY + 'px' }" @mouseenter="onImgEnter" @mouseleave="onImgLeave" />
    </div>

    <!-- 新闻区 -->
    <div class="news-section">
      <div class="container">
        <div class="news-headline" @click="goNewsDetail(headObj)">
          <h2>{{ headObj.title }}</h2>
          <p>{{ headObj.summary }}</p>
        </div>
        <div class="news-body">
          <el-carousel height="450px" style="width: 590px">
            <el-carousel-item v-for="item in newsList2" :key="item.id">
              <div class="news-image-box" style="width: 100%" @click="goNewsDetail(item)">
                <img :src="item.coverImage ? 'https://www.lingqitong.cn/stage-api' + item.coverImage.split(',')[0] : ''" alt="新闻图片" />
                <div class="news-image-caption">
                  <div style="width: 400px;overflow: hidden;text-overflow: ellipsis;white-space: nowrap;">{{ item.title }}</div>
                </div>
              </div>
            </el-carousel-item>
          </el-carousel>
          <div class="news-list-panel">
            <div class="news-items">
              <div class="news-item" v-for="(item, idx) in newsList3" :key="idx" @click="goNewsDetail(item)">
                <span class="news-dot" :style="{'color': (idx === 0 || idx === 1 || idx === 2) ? '#FF5600' : '','font-weight': (idx === 0 || idx === 1 || idx === 2) ? 'bold' : ''}">&#9632;</span>
                <span class="news-title text-overflow" :style="{'color': (idx === 0 || idx === 1 || idx === 2) ? '#FF5600' : '','font-weight': (idx === 0 || idx === 1 || idx === 2) ? 'bold' : ''}">{{ item.title }}</span>
                <span class="news-date" :style="{'color': (idx === 0 || idx === 1 || idx === 2) ? '#FF5600' : '','font-weight': (idx === 0 || idx === 1 || idx === 2) ? 'bold' : ''}">{{ item.publishTime }}</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- 快捷入口 -->
    <div style="background: #fff;padding-top: 10px">
      <div style="display: flex;justify-content: space-between;width: 1200px;margin: 0 auto" class="block">
        <img src="../assets/home/block1.png" alt="" width="292" height="120" @click="goQydt(2,8)">
        <img src="../assets/home/block2.png" alt="" width="292" height="120" @click="goQydt(2,5)">
        <img src="../assets/home/block3.png" alt="" width="292" height="120" @click="goHzPort()">
        <img src="../assets/home/block4.png" alt="" width="292" height="120" @click="goQydt(2,7)">
      </div>
    </div>

    <!-- 企业大厅 + 需求大厅 -->
    <div class="section-wrapper">
      <div class="container two-col">
        <!-- 企业大厅 -->
        <div class="section-block">
          <div class="section-header section-header1">
            <div></div>
            <span class="more-link" @click="$router.push('/enterpriseLibrary')">更多&gt;</span>
          </div>
          <div class="qy-body">
            <div class="qy-row">
              <div class="qy-type-label blue">
                <span>制</span><span>造</span><span>类</span>
              </div>
              <div class="qy-grid" style="background: #F7FAFE">
                <div class="qy-card" v-for="(n,index) in zzl" :key="n" @click="goQydt(1,index + 1)">
                  <div class="qy-card-img">
                    <img :src="require('../assets/home/zz' + (index + 1) + '.png')" alt="" width="36" height="36">
                  </div>
                  <div class="qy-card-name">{{n}}</div>
                </div>
              </div>
            </div>
            <div class="qy-row">
              <div class="qy-type-label orange">
                <span>服</span><span>务</span><span>类</span>
              </div>
              <div class="qy-grid" style="background: #FFF6F5">
                <div class="qy-card" v-for="(n,index) in fwl" :key="n" @click="goQydt(2,index + 1)">
                  <div class="qy-card-img">
                    <img :src="require('../assets/home/fw' + (index + 1) + '.png')" alt="" width="36" height="36">
                  </div>
                  <div class="qy-card-name">{{n}}</div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- 需求大厅 -->
        <div class="section-block">
          <div class="section-header section-header2">
            <div></div>
            <span class="more-link" @click="$router.push('/demandHall')">更多&gt;</span>
          </div>
          <div class="xq-tabs">
            <span v-for="(tab, idx) in xqTabLabels" :key="idx" :class="{ active: active1 === idx }"
              @mouseenter="xqClick(idx)">{{ tab }}</span>
          </div>
          <div class="xq-list">
            <div class="xq-item" v-for="item in xqList" :key="item.needId" @click="goXqDetails(item.needId)">
              <span class="xq-dot">&#9632;</span>
              <span class="xq-title text-overflow">{{ item.needTitle }}</span>
              <span class="xq-date">{{ item.createTime.slice(0,11) }}</span>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- 活动中心 + 政策中心 -->
    <div class="section-wrapper" style="margin-top: -30px;">
      <div class="container two-col">
        <!-- 活动中心 -->
        <div class="section-block">
          <div class="section-header section-header3">
            <div></div>
            <span class="more-link" @click="$router.push('/activityCenter')">更多&gt;</span>
          </div>
          <div style="background: #F0F5FF;padding: 10px;min-height: 430px">
            <div class="hd-months">
              <div class="month-item" v-for="item in monthList" :key="item.dictkey"
                   :class="{ active: current_month == item.dictkey }" @mouseenter="changeCalendar(item.dictkey)">
                <div class="month-label">{{ item.dictkey }}月</div>
                <div class="month-num">{{ item.countValue }}项</div>
              </div>
            </div>
            <div class="hd-list">
              <div class="hd-card" v-for="item in hdList" :key="item.activityId" @click="toHdDetail(item.activityId)">
                <div class="hd-row">
                  <span class="hd-tag">{{ item.activityTypeName }}</span>
                  <span class="hd-name text-overflow">{{ item.activityTitle }}</span>
                </div>
                <div class="hd-info">
                  <div class="text-overflow">活动地址：{{ item.activityAddress }}</div>
                  <span>报名截止：{{ item.deadlineTime }}</span>
                </div>
              </div>
              <div v-if="hdList.length === 0" class="empty-tip">暂无活动</div>
            </div>
          </div>
        </div>

        <!-- 政策中心 -->
        <div class="section-block">
          <div class="section-header section-header4">
            <div></div>
            <span class="more-link" @click="$router.push('/policyCenter')">更多&gt;</span>
          </div>
          <div class="zc-list">
            <div class="zc-item" v-for="item in zczxList" :key="item.policyId" @click="goZcDetails(item.policyId)">
              <span class="zc-dot">&#9632;</span>
              <span class="zc-title text-overflow">{{ item.policyTitle }}</span>
              <span class="zc-date">{{ item.createTime.slice(0,11) }}</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { getToken } from "@/utils/auth";
import { MessageBox } from "element-ui";

export default {
  name: 'HomeView',
  data() {
    return {
      token: '',
      // 碰撞反弹相关
      bouncingImgSrc: require('../assets/home/apiao.png'),
      imgX: 100, imgY: 100, imgVx: 2.5, imgVy: 2,
      imgWidth: 200, imgHeight: 150,
      animFrameId: null, isPaused: false,
      // 新闻
      headObj: {},
      newsList2: [],
      newsList3: [],
      // 需求大厅标签
      xqTabLabels: ['采购需求', '销售需求', '合作需求', '融资需求', '人才需求'],
      // 原有数据
      current_month: new Date().getMonth() + 1,
      hdList: [], monthList: [], noticeList: [],
      activeName: '1', active: 0, active1: 0,
      zczxList: [], xqList: [], qy: [], qyList: [], sys_policy_level: [],
      zzl: ['土工材料','高端装备','食品加工','建筑工程','化工与医药','新能源汽车','新材料','纺织服装','轻工产业链'],
      fwl: ['交通运输','仓储物流','科研技术','软件信息','租赁商务','文体教育卫生','人力资源','金融服务'],
    }
  },
  mounted() {
    // this.$nextTick(() => { setTimeout(() => { this.getScollData(); }, 100); });
    this.token = getToken();
    // this.getQy();
    // this.qyClick('1', 0);
    this.getNewList1();
    this.getNewList2();
    this.getNewList3();
    this.xqClick(0);
    // this.getPolicy_level();
    this.getZczx();
    this.changeCalendar(this.current_month);
    this.getCalendarNum();
    this.startBouncing();
  },
  beforeDestroy() {
    if (this.animFrameId) { cancelAnimationFrame(this.animFrameId); }
  },
  methods: {
    startBouncing() {
      const animate = () => {
        if (!this.$refs.bouncingWrapper) return;
        if (!this.isPaused) {
          const cw = window.innerWidth, ch = window.innerHeight;
          this.imgX += this.imgVx; this.imgY += this.imgVy;
          if (this.imgX <= 0) { this.imgX = 0; this.imgVx = Math.abs(this.imgVx); }
          else if (this.imgX + this.imgWidth >= cw) { this.imgX = cw - this.imgWidth; this.imgVx = -Math.abs(this.imgVx); }
          if (this.imgY <= 0) { this.imgY = 0; this.imgVy = Math.abs(this.imgVy); }
          else if (this.imgY + this.imgHeight >= ch) { this.imgY = ch - this.imgHeight; this.imgVy = -Math.abs(this.imgVy); }
        }
        this.animFrameId = requestAnimationFrame(animate);
      };
      this.animFrameId = requestAnimationFrame(animate);
    },
    onImgEnter() { this.isPaused = true; },
    onImgLeave() { this.isPaused = false; },
    getNewList1() {
      this.$http.get('/lc/news/weblist?pageNum=1&pageSize=1&category=1', { headers: { isToken: false } }).then(res => {
        if (res.rows.length > 0) {
          this.headObj = res.rows[0];
        }
      });
    },
    getNewList2() {
      this.$http.get('/lc/news/weblist?pageNum=1&pageSize=4&category=2', { headers: { isToken: false } }).then(res => { this.newsList2 = res.rows; });
    },
    getNewList3() {
      this.$http.get('/lc/news/weblist?pageNum=1&pageSize=10&category=3', { headers: { isToken: false } }).then(res => { this.newsList3 = res.rows; });
    },
    goNewsDetail(item) {
      if (item.isLink === 1) {
        window.open(item.linkUrl);
        return
      }

      window.open('/newsCenterDetails/' + item.id);
    },
    goQydt(id1, id2) {
      if (id1 === 2 && (id2 === 7 || id2 === 8)) {
        if (id2 === 7) {
          this.$router.push('/talentSupply')
        } else if (id2 === 8) {
          this.$router.push('/financial')
        }
      } else if (id1 === 2 && id2 === 6) {
        this.$router.push('/enterpriseLibrary?id1=' + id1 + '&id2=8')
      } else {
        this.$router.push('/enterpriseLibrary?id1=' + id1 + '&id2=' + id2)
      }
    },
    goHzPort() {
      this.$router.push('/hzPort')
    },
    toDetial(type, id) {
      if (type === 'policy') window.open('/policyCenterDetails/' + id);
      else if (type === 'activity') window.open('/activityCenterDetails/' + id);
      else if (type === 'need') window.open('/demandHallDetails/' + id);
    },
    getScollData() {
      this.$http.get('/api/getLatestRelease').then(res => { this.noticeList = res.rows; });
    },
    getQy() {
      this.$http.get('getCountByIndustry', {}).then(res => { this.qy = res.data; });
    },
    qyClick(dictkey, index) {
      this.active = index;
      this.$http.get('/system/info/list?pageNum=1&pageSize=10&entIndustry=' + dictkey).then(res => { this.qyList = res.rows; });
    },
    xqClick(index) {
      this.active1 = index;
      this.$http.get('/api/need/list?pageNum=1&pageSize=8&needType=' + (index + 1)).then(res => { this.xqList = res.rows; });
    },
    getPolicy_level() {
      this.$http.get('/system/dict/data/type/sys_policy_level').then(res => { this.sys_policy_level = res.data; });
    },
    getZczx() {
      this.$http.get('/api/policy/list?pageNum=1&pageSize=10', { headers: { isToken: false } }).then(res => { this.zczxList = res.rows; });
    },
    goZczx(dictValue) {
      this.$router.push({ path: '/policyCenter', query: { dictValue } });
    },
    changeCalendar(item) {
      this.current_month = item;
      this.$http.get('/api/activity/list?pageNum=1&pageSize=3&month=' + this.current_month, {}).then(res => {
        this.hdList = res.rows;
      });
    },
    getCalendarNum() {
      this.$http.get('/entNeed/getCountByMonth', {}).then(res => { this.monthList = res.data; });
    },
    toHdDetail(activityId) { window.open('/activityCenterDetails/' + activityId); },
    goZcDetails(policyId) { window.open('/policyCenterDetails/' + policyId); },
    goXqDetails(needId) { window.open('/demandHallDetails/' + needId); },
    goQyz(entId) { window.open('/enterpriseWebsite/' + entId); },
    toAddNeed() {
      if (!this.token) {
        MessageBox.confirm('发布需要先登录，您可以继续留在该页面，或者去登录', '系统提示',
          { confirmButtonText: '去登录', cancelButtonText: '取消', type: 'warning' }).then(() => { location.href = '/loginRegister'; });
        return;
      }
      window.open('/releaseRequirements');
    },
    toAddAppeal() {
      if (!this.token) {
        MessageBox.confirm('发布需要先登录，您可以继续留在该页面，或者去登录', '系统提示',
          { confirmButtonText: '去登录', cancelButtonText: '取消', type: 'warning' }).then(() => { location.href = '/loginRegister'; });
        return;
      }
      window.open('/releaseAppeal');
    },
  }
}
</script>

<style scoped lang="scss">
.container { width: 1200px; margin: 0 auto; }
.text-overflow { overflow: hidden; text-overflow: ellipsis; white-space: nowrap; }

.bouncing-wrapper { position: fixed; top: 0; left: 0; width: 100vw; height: 100vh; pointer-events: none; z-index: 9999; }
.bouncing-img { position: absolute; width: 200px; height: 150px; box-shadow: 0 4px 16px rgba(44,128,212,0.4); transition: transform 0.2s, box-shadow 0.2s; will-change: left, top; pointer-events: auto; cursor: pointer; }
.bouncing-img_paused { animation: pulse 1.2s ease-in-out infinite; }
@keyframes pulse { 0%,100%{opacity:1} 50%{opacity:0.6} }

.news-section { background: #fff; padding: 20px 0;
  .news-headline { text-align: center; margin-bottom: 18px;
    h2 { font-size: 30px; color: #0D56BD; margin: 30px auto 10px; max-width: 900px; }
    p { font-size: 18px; color: #333; line-height: 1.8; max-width: 950px; margin: 10px auto 50px;
      display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 2;  /* 限制文本显示为两行 */
    overflow: hidden;
    text-overflow: ellipsis; }
  }
  .news-headline:hover{
    cursor: pointer;
    h2 { text-decoration: underline; }
    p { color: #333; }
  }
  .news-body { display: flex; gap: 20px;
    .news-image-box { width: 590px; flex-shrink: 0; position: relative;
      img { width: 100%; height: 450px; object-fit: cover; display: block; }
      .news-image-caption { position: absolute; bottom: 0; left: 0; right: 0; background: rgba(0,0,0,0.6); color: #fff; padding: 0 12px; line-height: 50px; font-size: 17px; }
    }
    .news-image-box:hover {
      cursor: pointer;
    }
    .news-list-panel { flex: 1;
      .news-tabs { display: flex; margin-bottom: 4px;
        span { padding: 5px 12px; font-size: 18px; color: #666; cursor: pointer; border-radius: 3px; margin-right: 4px;
          &.active { color: #fff; background: #0D56BD; }
        }
      }
      .news-items {
        .news-item { display: flex; align-items: center; line-height: 45px; font-size: 18px; cursor: pointer;
          .news-dot { color: #0D56BD; font-size: 6px; margin-right: 8px; flex-shrink: 0; }
          .news-title { width: 476px; color: #333;
            &:hover { color: #0D56BD; }
          }
          .news-date { color: #333; font-size: 18px; margin-left: 10px; flex-shrink: 0; }
        }
      }
    }
  }
  .news-body ::v-deep .el-carousel__indicators--horizontal {
    right: 12px;
    bottom: 8px;
    transform: none;
    text-align: right;
  }
}

.section-wrapper { background: #fff; padding: 30px 0;
  &.bg-gray { background: #f5f7fa; }
  .two-col { display: flex; gap: 20px; }
  .section-block { flex: 1; background: #fff; border-radius: 4px; border: 1px solid #e0e0e0; padding: 0 14px 14px;
    .section-header { display: flex;justify-content: space-between;height: 60px;margin-bottom: 20px;
      .more-link { font-size: 13px; color: #999; cursor: pointer;line-height: 60px;
        &:hover { color: #0D56BD; }
      }
    }
    .section-header1 {
      background: url(../assets/home/title1.png);
    }
    .section-header2 {
      background: url(../assets/home/title2.png);
    }
    .section-header3 {
      background: url(../assets/home/title3.png);
    }
    .section-header4 {
      background: url(../assets/home/title4.png);
    }
  }
}

.block {
  img {
    transition: transform 0.2s;
  }
  img:hover {
    cursor: pointer;
    transform: translateY(-5px);
  }
}

.qy-body {
  .qy-row { display: flex; margin-bottom: 16px;
    &:last-child { margin-bottom: 0; }
    .qy-type-label { width: 50px; flex-shrink: 0; border-bottom-left-radius: 10px; border-top-left-radius: 10px; display: flex; flex-direction: column; align-items: center; justify-content: center; padding: 14px 0; font-size: 18px; font-weight: bold; color: #fff; line-height: 1.6;
      &.blue { background: #0D56BD; }
      &.orange { background: #DA5445; }
    }
    .qy-grid { flex: 1; display: flex; flex-wrap: wrap;
      .qy-card { width: 102px; text-align: center; padding: 15.5px 0; cursor: pointer; transition: all 0.2s; display: flex; flex-direction: column; justify-content: center;
        &:hover { transform: translateY(-5px); }
        .qy-card-img { margin: 0 auto 6px; font-size: 0 }
        .qy-card-name { font-size: 17px; color: #333; }
      }
    }
  }
}

.xq-tabs { display: flex; gap: 6px; margin-bottom: 4px;
  span { padding: 5px 12px; font-size: 18px; color: #666; border-radius: 6px; cursor: pointer;
    &.active { color: #fff; background: #0D56BD; }
  }
}
.xq-list {
  .xq-item { display: flex; align-items: center; line-height: 46px; font-size: 18px; cursor: pointer;
    .xq-dot { color: #0D56BD; font-size: 7px; margin-right: 8px; flex-shrink: 0; }
    .xq-title { width: 446px; color: #333;
      &:hover { color: #0D56BD; }
    }
    .xq-date { color: #333; font-size: 18px; margin-left: 10px; flex-shrink: 0; }
  }
}

.hd-months { display: flex; justify-content: space-between; margin-bottom: 14px;
  .month-item { text-align: center; padding: 5px 0; border-radius: 6px; cursor: pointer; min-width: 44px;
    &.active { background: #0D56BD; color: #fff; }
    .month-label { font-size: 16px; font-weight: bold; }
    .month-num { font-size: 13px; margin-top: 2px; }
  }
}
.hd-list {
  .hd-card { height: 93px;padding: 10px; border: 1px solid #e8e8e8; background: #ffffff; border-radius: 4px; margin-top: 8px; cursor: pointer; transition: all 0.2s;display: flex;flex-direction: column;justify-content: space-evenly;
    &:hover {
      border-color: #0D56BD;
      transform: translateY(-5px);
      .hd-row {
        .hd-name {
          color: #0D56BD;
        }
      }
    }
    .hd-row { display: flex; align-items: center;
      .hd-tag { display: inline-block; padding: 2px 8px; background: #eaf2fc; color: #0D56BD; font-size: 14px; border-radius: 3px; margin-right: 8px; flex-shrink: 0; }
      .hd-name { font-size: 18px; color: #333; width: 438px }
    }
    .hd-info { font-size: 15px; color: #888; display: flex; justify-content: space-between;
      div { width: 356px }
      span { margin-left: 10px; }
    }
  }
  .empty-tip { text-align: center; color: #999; padding: 24px; font-size: 13px; }
}

.zc-list {
  .zc-item { display: flex; align-items: center; line-height: 45px; font-size: 18px; cursor: pointer;
    .zc-dot { color: #0D56BD; font-size: 7px; margin-right: 8px; flex-shrink: 0; }
    .zc-title { width: 446px; color: #333;
      &:hover { color: #0D56BD; }
    }
    .zc-date { color: #333; font-size: 18px; margin-left: 10px; flex-shrink: 0; }
  }
}
</style>
